import { render, staticRenderFns } from "./EditDateDialog.vue?vue&type=template&id=f2bc6640&scoped=true&"
import script from "./EditDateDialog.vue?vue&type=script&lang=js&"
export * from "./EditDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc6640",
  null
  
)

export default component.exports